export default {
	enrichArmMeta(armMeta) {
		if (armMeta.editHistoryEnabled === 'INCLUDE_CHILD') {
			armMeta.childArms.push({
				armId: 77701,
				childCaption: 'История изменений',
				targetColumn: 'record_id', // arm_id
				// sourceColumn: 'ID',
			})
		}
	},
	armIdIsJournal: id => +id === 77701
}
